<div class="sidebar-logo">
  <img [src]="themeService.getLogo()">
</div>
